import { ISale } from "state/sales";
import { truncateInMiddle } from "utils/truncateInMiddle";

export const getOwnerAddress = ({ artwork: { ownerAddress } }: ISale) => {
  return ownerAddress ? truncateInMiddle(ownerAddress) : "-";
};
